export const searchOrigins = {
  FOOTER_SEARCH_SUBURB: 'Footer Search by Suburb',
  FOOTER_SEARCH_SUGGESTION: 'Footer Search Suggestion', // Not implemented
  JOB_SEARCH_HOME: 'Job Search (Home)',
  JOB_SEARCH_SERP: 'Job Search (SERP)',
  LOCATION_SUGGESTIONS: 'Location Suggestions', // Not implemented
  OTHERS: 'Others',
  QUICK_SEARCH: 'Quick Search (Home)', // Not implemented
  RECENT_SEARCH: 'Recent Search',
  RELATED_SEARCH: 'Related Search',
  SAVED_SEARCH_HOME: 'Saved Search (Home)', // Not implemented
  SAVED_SEARCH_MY_ACTIVITY: 'Saved Search (My Activity)', // Not implemented
} as const;
export type SearchOrigin = (typeof searchOrigins)[keyof typeof searchOrigins];
